export const WEEKLY = {
  value: "WEEKLY",
  key: "clients.client.reports.payrollDeductions.form.WEEKLY",
};
export const BIWEEKLY = {
  value: "BIWEEKLY",
  key: "clients.client.reports.payrollDeductions.form.BIWEEKLY",
};
export const SEMIMONTHLY = {
  value: "SEMIMONTHLY",
  key: "clients.client.reports.payrollDeductions.form.SEMIMONTHLY",
};
export const MONTHLY = {
  value: "MONTHLY",
  key: "clients.client.reports.payrollDeductions.form.MONTHLY",
};
export const MONTHLY_WITH_CREDITS = {
  value: "MONTHLY_WITH_CREDITS",
  key: "clients.client.reports.payrollDeductions.form.MONTHLY_WITH_CREDITS",
};
export const ANNUAL = {
  value: "ANNUAL",
  key: "clients.client.reports.payrollDeductions.form.ANNUAL",
};
export const ANNUAL_WITH_CREDITS = {
  value: "ANNUAL_WITH_CREDITS",
  key: "clients.client.reports.payrollDeductions.form.ANNUAL_WITH_CREDITS",
};

export default [WEEKLY, BIWEEKLY, SEMIMONTHLY, MONTHLY, MONTHLY_WITH_CREDITS, ANNUAL, ANNUAL_WITH_CREDITS];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/reports/enums/payrollReportFrequencyTypes.js